import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Footer from "../footer";
import RegisterVisual from "../Visual/registerVisual";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import config from "../../Api/config";
import { useSession } from "../sessionProvider";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React from "react";

type FormInputs = {
    file: FileList, 
};

function RegisterItem() {

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    let sapCode = searchParams.get("SAPCode");
    let productID = searchParams.get("productID");

    const notifyError = (err:any) => toast.error(err,{theme:"colored"});
    const notifySuccess = (text:any) => toast.success(text,{theme:"colored"});

    const {register, handleSubmit, setError, formState: {errors}} = useForm<FormInputs>();
    const [manufacturers, setManufacturers] = useState<any[]>([]);
    const [selectedManu, setSelectedManu] = useState("");

    const { ownerId } = useSession();


    const [date, setDate] = React.useState(dayjs(new Date()));

    const [manufacturerAccess, setManufacturerAccess] = useState({
        //timestamp: "",
        //batch_material: "",
        //price: "",
        //lc_deviation: ""
        batch_material: "",
        actual_production_price: "",
        planned_production_price: "",
        actual_planned_diff_in_eur: "",
        actual_planned_diff_percentage: ""
    });

    const [itemData, setItemData] = useState({
        sap_product_code: sapCode == undefined ? "":sapCode ,
        manufacturer_id: selectedManu,
        timestamp:(dayjs(new Date()).toISOString()),
        project_age:(dayjs(new Date()).toISOString()),
        batch_number:"",
        manufacturer_access:manufacturerAccess,
        product_id:productID,
    });
   
    useEffect(() => {
        config.API.getManufacturers(ownerId, "","").then(async (response) => {
            console.log(response);

            if(response.results.length > 0 && response.results[0] != undefined && response.results[0]["id"] != undefined){
                setSelectedManu(response.results[0]["id"]);
                setItemData({...itemData, manufacturer_id: response.results[0]["id"]});
            }
            
            setManufacturers(
                response.results.map((val) => {
                return {
                  value: val.id,
                  label: val.name ,
                }; })
            );
        })
    }, []);
    
    const changeItemData = (name: string, data: any): void => {
        setItemData({ ...itemData, [name]: data });
    };

    const changeManufacturerAccess = (name: string, data: any): void => {
        setManufacturerAccess({ ...manufacturerAccess, [name]: data });
    };

    const handleChangeManu = (event: SelectChangeEvent) => {
        setSelectedManu(event.target.value);
        setItemData({...itemData, manufacturer_id: event.target.value});
    };

    const handleDatechange = (event:any) => {
        setItemData({...itemData, project_age: event.toISOString()});
    };

    const onSubmitForm: SubmitHandler<FormInputs> = (data: FormInputs) => { 
        config.API.addItem(ownerId, {...itemData,manufacturer_access:manufacturerAccess}).then((edited) => {
            if(edited) {
                notifySuccess("Created new DPP");
                navigate('/products');
            }
        }).catch(error => {
            console.error("Error in API Issue: ", error);
            notifyError("Error in creating new DPP: " + JSON.stringify(error));
        });
    }    

    return(<>
        <div className="company">

            <RegisterVisual title={"Create new DPP"}/>

            <div className="explorer">

                <form className="form" onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        handleSubmit(onSubmitForm)(event);
                    }} >

                    <div>
                        <label> <span className="requiredMark">*</span> Manufacturer ID {" "} </label>
                        <Select
                            required
                            defaultValue={manufacturers.length > 0   ? manufacturers[0].value : ""}
                            className="template-field selector"
                            value={ manufacturers.length > 0 && !selectedManu ? manufacturers[0].value : selectedManu }
                            onChange={handleChangeManu}
                        >
                            <MenuItem disabled value="Select manufacturer ID">
                            <em>Manufacturer ID </em>
                            </MenuItem>
                            {manufacturers ? (
                            manufacturers.map((item) => {
                                return (
                                <MenuItem
                                    
                                    selected={manufacturers[0].value === item.value}
                                    key={item.value}
                                    value={item.value}
                                    className="issuer-form selector" 
                                >
                                    {item.label}
                                </MenuItem>
                                );
                            })
                            ) : (
                            <></>
                            )}
                        </Select>
                    </div>
                    <div>
                        <label> <span className="requiredMark">*</span> Item Timestamp {" "} </label>
                        <input type="text" className="issuer-form" name="timestamp" maxLength={1000} placeholder={"e.g., 2023-10-17T08:10:44.574Z"} value={itemData.timestamp } onChange={(event) => { changeItemData("timestamp", event.target.value); }} required ></input>
                    </div>
                    <div>
                        <label> <span className="requiredMark">*</span> Date Of The Project{" "} </label>
                        {/*<input type="text" className="issuer-form" name="project_age" maxLength={140} placeholder="Date of the start of the project" value={itemData.project_age } onChange={(event) => { changeItemData("project_age", event.target.value); }}  ></input>*/}
                    
                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                            <DatePicker className="issuer-form datepicker" 
                                value={date}
                                onChange={handleDatechange} />
                        </LocalizationProvider>
                    </div>
                    <div>
                        <label> <span className="requiredMark">*</span> Batch number{" "} </label>
                        <input type="text" className="issuer-form" name="batch_number" maxLength={1000} placeholder="e.g., 1234" value={itemData.batch_number } onChange={(event) => { changeItemData("batch_number", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> SAP Product Code{" "} </label>
                        <input type="text" className="issuer-form" name="sap_product_code" maxLength={1000} placeholder="ABC123" value={itemData.sap_product_code } onChange={(event) => { changeItemData("sap_product_code", event.target.value); }}  ></input>
                    </div>


                    <div>
                        <h4>Manufacturer Access {" "} </h4>
                        {/*<div>
                            <label> Manufacturer Access Timestamp{" "} </label>
                            <input type="text" className="issuer-form" name="timestamp" maxLength={1000} placeholder="e.g., 2023-10-17T08:10:44.574Z" value={manufacturerAccess.timestamp } onChange={(event) => { changeManufacturerAccess("timestamp", event.target.value); }}  ></input>
                        </div>*/}
                        <div>
                            <label> Batch Material{" "} </label>
                            <input type="text" className="issuer-form" name="batch_material" maxLength={1000} placeholder="e.g., Batch123" value={manufacturerAccess.batch_material  } onChange={(event) => { changeManufacturerAccess("batch_material", event.target.value); }}  ></input>
                        </div>
                        {/*<div>
                            <label> Price{" "} </label>
                            <input type="text" className="issuer-form" name="price" maxLength={1000} placeholder="e.g., 100€" value={manufacturerAccess.price  } onChange={(event) => { changeManufacturerAccess("price", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label> LC Deviation {" "} </label>
                            <input type="text" className="issuer-form" name="lc_deviation" maxLength={1000} placeholder="e.g., 5%" value={manufacturerAccess.lc_deviation } onChange={(event) => { changeManufacturerAccess("lc_deviation", event.target.value); }}  ></input>
                        </div>*/}

                        <div>
                            <label> Actual Production Price{" "} </label>
                            <input type="text" className="issuer-form" name="actual_production_price" maxLength={1000} placeholder="e.g., 50€" value={manufacturerAccess.actual_production_price  } onChange={(event) => { changeManufacturerAccess("actual_production_price", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label> Planned Production Price {" "} </label>
                            <input type="text" className="issuer-form" name="planned_production_price" maxLength={1000} placeholder="e.g., 80€" value={manufacturerAccess.planned_production_price } onChange={(event) => { changeManufacturerAccess("planned_production_price", event.target.value); }}  ></input>
                        </div>

                        <div>
                            <label> Actual Planned Diff (eur){" "} </label>
                            <input type="text" className="issuer-form" name="actual_planned_diff_in_eur" maxLength={1000} placeholder="e.g., 30€" value={manufacturerAccess.actual_planned_diff_in_eur  } onChange={(event) => { changeManufacturerAccess("actual_planned_diff_in_eur", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label> Actual Planned Diff (%) {" "} </label>
                            <input type="text" className="issuer-form" name="actual_planned_diff_percentage" maxLength={1000} placeholder="e.g., 37.5%" value={manufacturerAccess.actual_planned_diff_percentage } onChange={(event) => { changeManufacturerAccess("actual_planned_diff_percentage", event.target.value); }}  ></input>
                        </div>
                        
                    </div>

                    <button  className="btn btn-primary" type="submit"> {'Create DPP'}</button>
                    <button  className="btn btn-secondary" onClick={() => {
                        navigate('/products');
                    }} > Back</button>
                </form>

            </div>

            <Footer/>
        </div>
    </>)
}

export default RegisterItem;
